import {
  Button,
  Modal
} from "antd";
import styled from "styled-components";
import useModal from "../../../hooks/useModalPlanejamentoOperacoes";
import { useGetHistoricoTalhao } from "../../../hooks/useGetHistoricoPlanejamentoOperacao";
import { ModalContainer} from "../styles";
import column from "./Histories";
import DatatableAntd from "components/datatable-antd";
import { formatarDataSemTimezone, getDataOrdenacao } from "../utils";

interface ModalHistoricoOperacaoProps {
  refetch?: () => void;
}

function ModalHistoricoOperacao({ refetch }: ModalHistoricoOperacaoProps) {
  const { 
    isModalHistoricoOperacao,
    setIsModalHistoricoOperacao,
    setPlanoOperacionalOperacaoTalhao,
    planoOperacionalOperacaoTalhao
  } = useModal();
  const { data: listHistorico, isFetching } = useGetHistoricoTalhao(planoOperacionalOperacaoTalhao?.planoOperacionalOperacaoTalhaoId!);

  function closedModal() {
    setIsModalHistoricoOperacao(false);

    setPlanoOperacionalOperacaoTalhao(null);
  }

  return (
    <CustomModal
      title={`Histórico de Operação ${formatarDataSemTimezone(planoOperacionalOperacaoTalhao?.operacaoNome!) ?? ''}`}
      visible={isModalHistoricoOperacao}
      onCancel={closedModal}
      zIndex={1001}
      width={"80%"}
      maskClosable={false}
      className="teste"
      footer={
        <>
          <Button
            size="large"
            onClick={closedModal}
            style={{ borderRadius: 8 }}
          >Fechar</Button>
        </>
      }
    >
      <ModalContainer>  
          <ModalTableContentWrap>
              <ContainerTable>
              <RoundedTable
                  style={{ marginBottom: 16 }}
                  columns={column()}
                  dataSource={isFetching ? [] : listHistorico?.sort((a, b) => getDataOrdenacao(a) - getDataOrdenacao(b))}
                  className="my-table"
                  scroll={{
                  y: '100%',
                  }}
                  sticky
                  pagination={false}
              />
              </ContainerTable>
          </ModalTableContentWrap>
        </ModalContainer>
    </CustomModal>
  );
}

const CustomModal = styled(Modal)`
  position: relative;
  /* height: 90%; */
  /* max-height: 90vh; */
  max-height: 60vh;

  .ant-modal-content {
    border-radius: 10px;
    height: 100%;
    
    display: flex;
    flex-direction: column;
  }

  .ant-modal-header {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #12619C;
    height: 61px;
  }

  .ant-modal-title {
    color: #fff;
    font-weight: bold;
  }

  .ant-modal-close-x {
    color: #fff;
  }

  .ant-form-item-required::before {
      content: none !important;
    }

  .ant-form-item-required::after {
    display: inline-block !important;
    margin-left: 4px !important;
    color: red;
    font-size: 14px !important;
    line-height: 1 !important;
    content: "*" !important;
  }

  .ant-modal-body {
    padding: 0;
    position: relative;

    height: calc(60vh - 122px);
    display: flex;
    flex-direction: column;
    flex: 0 0 auto;

    overflow: hidden;
  }

  .ant-modal-footer {
    height: 61px;
  }

  .inner-overlay {
    position: absolute;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.45);
    z-index: 5;
    backdrop-filter: blur(2px);
  }
`;

const ContainerTable = styled.div`
  flex: 1;
  min-height: 0; 

  padding-bottom: 25px;

  > div > div > div > div > div,
  > div > div > div > div > div > div,
  .ant-table-cell:has(input) {
    overflow: visible !important;
  }

  .css-0, 
  .ant-table-wrapper, 
  .ant-spin-nested-loading, 
  .ant-spin-container, 
  .ant-table, 
  .ant-table-container {
    height: 100%;
  }

  position: relative;
  width: 100%;

  .ant-table {
    table-layout: fixed !important;
  }

  .ant-table-container {
    overflow: visible !important;
  }


.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  white-space: nowrap;
}

  .ant-select {
    cursor: text;
    min-width: 100px;
    border-radius: 0.375rem;
  }
  .ant-select-selector {
    height: 2.4rem;
  }
`;

const ModalTableContentWrap = styled.div`
  display: flex;
  flex-direction: column;
  /* height: 100%; */
  flex: 1;
  min-height: 0;
`;

const RoundedTable = styled(DatatableAntd)`
  .ant-table {
    border-radius: 8px;
    overflow: hidden;
  }

  .ant-table-container {
    border-radius: 8px;
    overflow: hidden;
  }

`;

export default ModalHistoricoOperacao;